import { css } from "lit";

export const styles = css`
  .stream-stats-section {
    margin-top: 24px;
    padding: 20px;
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-border-radius-03);
    border: 1px solid var(--sds-color-border-default-tertiary);
  }

  .stats-header {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-03) var(--sds-typography-family-title);
    color: var(--sds-color-text-default-primary);
    margin-bottom: 16px;
  }

  .loading-state,
  .error-message {
    text-align: center;
    padding: 24px;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-02) var(--sds-typography-family-body);
  }

  .error-message {
    color: var(--sds-color-text-danger-default);
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 16px;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .stat-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .stat-value {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-03) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-primary);
  }

  .stat-value.status-live {
    color: var(--sds-color-text-success-default);
  }

  .stat-value.status-offline {
    color: var(--sds-color-text-default-tertiary);
  }

  @media (max-width: 768px) {
    .stream-stats-section {
      padding: 16px;
      margin-top: 20px;
    }

    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }

    .stat-value {
      font-size: var(--sds-typography-scale-02);
    }
  }
`;
